import * as React from "react";
import styled, { css } from "styled-components";
import { Icon, Spinner, HoverForHelp } from "components/common";
import { Row } from "common/components";
const StatusTitle = styled.h2`
  margin-bottom: 1rem;
`;
const PackTitles = styled.div`
  display: flex;
  flex-direction: column;
`;
const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.3rem 0;

  > :first-child {
    margin-right: 1rem;
  }
`;
const InProgressStep = styled.div`
  -webkit-animation: pulsate 3s ease-out;
  -webkit-animation-iteration-count: infinite;
  opacity: 0.5;
  display: flex;
  flex-direction: row;
  margin: 0.3rem 0;

  > :first-child {
    margin-right: 1rem;
  }

  @-webkit-keyframes pulsate {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`;
const IconContainer = styled.div`
  width: 18px;
  display: inline-block;
  text-align: left;
`;
const StatusIcon = styled(Icon)(
  ({ theme, $success }) => css`
    color: ${$success ? theme.colors.variant.success : theme.colors.variant.danger};
  `
);
const IlluminateInstallStatus = ({ installStatusObj }) => {
  const renderStatusIcon = (success) => /* @__PURE__ */ React.createElement(IconContainer, null, success ? /* @__PURE__ */ React.createElement(StatusIcon, { name: "check", $success: true }) : /* @__PURE__ */ React.createElement(StatusIcon, { name: "close" }));
  const packTitles = [...installStatusObj.pack_titles, ...installStatusObj.spotlight_pack_titles].sort(
    (a, b) => a.localeCompare(b)
  );
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StatusTitle, null, "Illuminate v", installStatusObj.illuminate_version, " install in progress..."), /* @__PURE__ */ React.createElement("div", null, installStatusObj.disable_packs ? "Disabling" : "Enabling", " packs:"), /* @__PURE__ */ React.createElement(PackTitles, null, packTitles.map((packTitle) => /* @__PURE__ */ React.createElement("strong", { key: packTitle }, packTitle))), installStatusObj.install_progress.map((installStep) => {
    const { install_in_progress, complete, successful, title, description } = installStep;
    return /* @__PURE__ */ React.createElement("div", { style: { marginTop: "10px" }, key: `install-step-${title}` }, complete ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StepItem, null, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, renderStatusIcon(successful), /* @__PURE__ */ React.createElement(HoverForHelp, { placement: "right" }, description), title))) : /* @__PURE__ */ React.createElement("div", null, install_in_progress ? /* @__PURE__ */ React.createElement(InProgressStep, null, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, /* @__PURE__ */ React.createElement(Spinner, { text: "" }), /* @__PURE__ */ React.createElement(HoverForHelp, { placement: "right" }, description), title)) : /* @__PURE__ */ React.createElement(StepItem, null, /* @__PURE__ */ React.createElement("div", null, title), /* @__PURE__ */ React.createElement("div", null, "Not started"))));
  }));
};
export default IlluminateInstallStatus;
